// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"D0-z"};